import { render, staticRenderFns } from "./TelephoneIcon.vue?vue&type=template&id=3536a17e&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3536a17e', component.options)
    } else {
      api.rerender('3536a17e', component.options)
    }
    module.hot.accept("./TelephoneIcon.vue?vue&type=template&id=3536a17e&functional=true&", function () {
      api.rerender('3536a17e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/TelephoneIcon.vue"
export default component.exports